module.exports = __webpack_public_path__ + "img/listar_services.79c1c1d7.svg";